import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PatientRegistrationData } from '../../../../@core/interfaces/patient-services/patient-registration';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DateService } from '../service/date.service';
import * as title from './../../../../data/title.json';
import { GeneralPackageTypeData } from '../../../../@core/interfaces/masters/generalpackagetype';
import { DischargeTmpl, DischargeTmplData } from '../../../../@core/interfaces/masters/discharge-tmpl';
import { NgxBarcodeComponent } from 'ngx-barcode';
import { StickersTemplateComponent } from '../stickers-template/stickers-template.component';

@Component({
  selector: 'ngx-stickers',
  templateUrl: './stickers.component.html',
  styleUrls: ['./stickers.component.scss']
})
export class StickersComponent implements OnInit {

  @Input ()regNum:string;
  @Input ()from:string;
  openStickerPopup:boolean=false;
  allowClear:boolean=true;
  printOptions:any=['OP Sticker','IP Sticker','Patient ID card']
  stickerForm:FormGroup;
  numberOfCopies: number;
  noOfCopies:number[]=[];
  copiesErr:boolean=false;
  stickerType:string;
  regAdmNo:string;
  data:any=[];
  selectedType:string;
  OP:string='OP';
  imageSrc:string;
  titleList: any = (title as any).default;
  tempDataList:Array<any>=[];
  printsettings:boolean=false
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  protected readonly unsubscribe$ = new Subject<void>();
  @ViewChild('stickerTemplate') StickerTmplComponent:StickersTemplateComponent
  @ViewChild('barcode', { static: false }) barcodeElement!: NgxBarcodeComponent;
  barcodeBase64:string
  stickerTmplData:DischargeTmpl
  constructor(public dateService:DateService,private fb: FormBuilder, protected patRegSrvc: PatientRegistrationData,protected generalPack:GeneralPackageTypeData,protected DischargeTmplSrvc: DischargeTmplData) {
    this.stickerForm = this.fb.group({
      stickerType:this.fb.control(null),
      stickerField:this.fb.control(null),
      copies: this.fb.control(null, [Validators.required, Validators.pattern('^[0-9]+$')]),
    })
   }

  ngOnInit(): void {
    this.serDefaultValues();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.generateBarcodeURL();
    }, 1000); 
  }

  get fval() { return this.stickerForm.controls; }

  serDefaultValues(){
    this.stickerForm.get('copies').setValue(1);
    if(this.from=='OP'){
      this.stickerForm.get('stickerType').setValue('OP Sticker');
      this.selectedType = this.stickerForm.get('stickerType').value;
      this.stickerType = 'OP';
      this.regAdmNo = this.regNum;
    }
    else if(this.from=='IP'){
      this.stickerForm.get('stickerType').setValue('IP Sticker');
      this.selectedType = this.stickerForm.get('stickerType').value;
      this.stickerType = 'IP';
      this.regAdmNo = this.regNum;
    }
    this.LoadDischargeTmpls();
    this.fetchOpIpDatas();
    this.onSubmit();
  }


  fetchOpIpDatas(){
    this.generalPack.listStickerDet(`PatientRegistrationMst/${this.tenantId}/${this.branchId}/getStickerDet`,this.stickerType,this.regAdmNo,0).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
       this.data=data;
       const binaryData = data.image;
       this.imageSrc = 'data:image/jpeg;base64,' + binaryData;

    },
    (error) => {     
    },
    () => { 
    });
  }
 
  onTypeChange(event){

  }
  onSubmit(){
    var copies=this.stickerForm.get('copies').value;
    this.getNumberArray(copies)
  }
  getNumberArray(num:number){
    this.noOfCopies= Array.from({ length: num }, (_, index) => index);
  }
  onReset(){
    this.stickerForm.reset();
    this.noOfCopies=[];
  }

  //copies validation
  cpyChnge(){
    var copies = Number(this.stickerForm.get('copies').value)
    if(copies > 100){
      this.copiesErr=true;
    }
    else{
      this.copiesErr=false;
    }
  }
  getPatientTitle(data){
    return this.titleList.find(e=>e.value==data)?.title;
  }

  LoadDischargeTmpls(): void { 
    this.DischargeTmplSrvc.list("dischargeTmpl/" + this.tenantId + "/getTemplateInfoByTemplateType/OP_Sticker?branchId="+this.branchId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        if(data.length>0){ 
          this.tempDataList=data.filter(x=>x.isActive=='Y')
          if(!!this.tempDataList && this.tempDataList!=undefined && this.tempDataList.length>0){
            this.printsettings=true;
            var templateData=this.tempDataList.find(x=>x.defaultFlag=="Y" && x.isActive=="Y")
          setTimeout(()=>{
            if(!!templateData){
              this.stickerForm.controls['stickerField'].setValue(templateData.id)
            }
            else{
              this.stickerForm.controls['stickerField'].setValue(this.tempDataList[0].id)
            }
          },1000)
          }
          else{
            this.printsettings=false;
          }
        } 
        else{
          this.printsettings=false;
        }
      
      
    }, (error) => {
        
    }, () => {
    });

  }
  printStickerTmpl():void{
    this.StickerTmplComponent.onPrint()
  }

 
  onStickerChange(args: any[]) {  
    this.StickerTmplComponent.editdata(args[0]?.data)
    this.stickerTmplData=args[0]?.data
}
  
  generateBarcodeURL() {
    const barcodeElement = this.barcodeElement.bcElement.nativeElement.querySelector('svg');
    if (barcodeElement) {
      const svgData = new XMLSerializer().serializeToString(barcodeElement);
    
      const base64 = btoa(unescape(encodeURIComponent(svgData)));
       this.barcodeBase64 = `data:image/svg+xml;base64,${base64}`;
 } 
  }
}
